"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _MyAccountError = _interopRequireDefault(require("../MyAccountError"));
var _InnerPopupWrapperStyled = require("./InnerPopupWrapperStyled");
var _jsxRuntime = require("react/jsx-runtime");
const InnerPopupWrapper = _ref => {
  let {
    steps,
    popupTitle,
    currentStep,
    children,
    isError
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.CardStyled, {
    children: isError ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountError.default, {
      generalError: true,
      centered: true
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.WrapperStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.HeaderStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.DotsWrapperStyled, {
          $currentStep: currentStep,
          children: steps > 1 && Array.from({
            length: steps
          }, (_, k) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.DotStyled, {}, k))
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.HeaderTitleStyled, {
          children: popupTitle
        })]
      }), children]
    })
  });
};
var _default = exports.default = InnerPopupWrapper;